module.exports = __webpack_public_path__ + "img/boxes_sell.459be619.png";